export default {
  UserGroup: {
    free: '免费用户',
    professional: '专业版',
    enterprise: '专业增强版',
    qihoo: '奇虎版'
  }
}
